import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { getRouteData } from '@mwe/utils';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-header',
  templateUrl: './header.component.html',
  imports: [NgClass, TranslateDirective],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  @Input() isLongHeader = false;
  @Input() isOrangeHeader = false;
  @Input() hideHeader = false;
  @Input() title: string | undefined;
  @Input() withBottomMargin = true;
  @Input() wideHeader = false;
  routeData: any; // TODO

  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.routeData = getRouteData(this.activatedRoute) || {};
    this.updateClasses();
    this.setPageTitle();
    const routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.routeData = getRouteData(this.activatedRoute) || {};
        this.updateClasses();
        this.setPageTitle();
      }
    });
    this.subscriptions.add(routerSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  updateClasses(): void {
    this.isLongHeader = this.routeData.isLongHeader;
    this.isOrangeHeader = this.routeData.isOrangeHeader;
    this.hideHeader = this.routeData.hideHeader;
  }

  setPageTitle(): void {
    if (this.routeData) {
      this.title = this.routeData.pageTitle;
    }
  }
}
